// extracted by mini-css-extract-plugin
export var container = "container_nPc1E1XWvcSF6vCQACmw";
export var panel = "panel_vYV6yR6Zu1y6RE4E2VVg";
export var savedSearchesPanel = "saved-searches-panel_HXBvGxsqoIJiNLmIAAN6";
export var sharedSearchesPanel = "shared-searches-panel_c9uTEau2CrUj81SfOJt_";